module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '0agsrhkh',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
